import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import type { IconDefinition } from "@fortawesome/fontawesome-svg-core";
import { LogoSplash } from "../../../config/brandAssets";

interface LogoImageProps {
  size?: "sm" | "md" | "lg";
  className?: string;
  appIcon?: IconDefinition | null;
  appIconColor?: string;
}

const sizeClasses = {
  sm: "w-7 h-7",
  md: "w-8 h-8",
  lg: "w-10 h-10",
};

const imgScales = {
  sm: "scale-[1.2]",
  md: "scale-[1.2]",
  lg: "scale-[1.2]",
};

const overlayClasses = {
  sm: "w-3 h-3 -right-1 -bottom-1",
  md: "w-4 h-4 -right-1.5 -bottom-1.5",
  lg: "w-5 h-5 -right-2 -bottom-2",
};

const overlayIconSizes = {
  sm: "text-[8px]",
  md: "text-[10px]",
  lg: "text-xs",
};

export default function LogoImage({ size = "md", className = "", appIcon, appIconColor }: LogoImageProps) {
  const containerClass = sizeClasses[size];
  const imgScale = imgScales[size];
  const overlayClass = overlayClasses[size];
  const overlayIconSize = overlayIconSizes[size];

  return (
    <div className={`relative ${className}`}>
      <div
        className={`${containerClass} bg-gradient-to-br from-primary-500 to-primary-400 rounded-lg flex items-center justify-center shadow-lg overflow-visible`}
      >
        <img
          src={LogoSplash}
          alt="Logo"
          className={`${imgScale} object-contain brightness-0 invert drop-shadow-[0_2px_4px_rgba(0,0,0,0.3)]`}
        />
      </div>
      {appIcon && appIconColor && (
        <div
          className={`absolute ${overlayClass} ${appIconColor} rounded flex items-center justify-center shadow-md`}
        >
          <FontAwesomeIcon icon={appIcon} className={`text-white ${overlayIconSize}`} />
        </div>
      )}
    </div>
  );
}
